<template>
  <div class="docs">
    <div class="container">
      <div class="docs__wrapper">
        <h1 class="docs__title">Terms and Conditions</h1>
        <div class="docs__block">
          <p>These Legal Terms constitute a binding agreement between you—whether using the Services for personal or business purposes (“you”)—and govern your use of the Services. By accessing the Services, you confirm that you have read, understood, and agree to comply with these Terms. IF YOU DO NOT AGREE WITH ANY PART OF THESE TERMS, YOU ARE STRICTLY PROHIBITED FROM USING THE SERVICES AND MUST IMMEDIATELY CEASE USE.</p>
        </div>
        <div class="docs__block">
          <h6>Our Services</h6>
          <p>ALCOR INNOVATIVE LTD S.R.L. specializes in software development for online platforms, including website creation and design, as well as providing software consulting services.</p>
          <p>The information you provide when using the Services is not intended for distribution or use by anyone in jurisdictions where doing so would violate local laws or require registration. Individuals accessing the Services from other countries do so on their own initiative and are solely responsible for complying with local regulations.</p>
        </div>
        <div class="docs__block">
          <h6>Content License</h6>
          <p>You consent to our access, storage, processing, and use of any information and personal data you provide, in accordance with our Privacy Policy and your selected preferences. By submitting suggestions or feedback about the Site, you grant us the right to use and share such input for any purpose, without any obligation to compensate you.</p>
        </div>
        <div class="docs__block">
          <h6>User Data</h6>
          <p>We retain certain data that you submit via the Site to ensure its performance, as well as information related to your usage. Although we perform regular backups, you are solely responsible for all data you transmit or that relates to your activity on the Site. We are not liable for any loss or corruption of such data, and you waive any right to pursue claims against us for such issues.</p>
        </div>
        <div class="docs__block">
          <h6>Prohibited Activities</h6>
          <p>You may not use the Services for any purpose other than those explicitly intended. The only commercial activities permitted are those officially approved or authorized by us.</p>
          <p>Without our prior written consent, you agree not to engage in the following:</p>
          <ul>
            <li>Systematically extracting data or content from the Services to compile a collection, database, or directory.</li>
            <li>Disparaging, damaging, or interfering with the functionality of the Services.</li>
            <li>Harassing, threatening, or harming other users based on information obtained through the Services.</li>
            <li>Intimidating or disturbing our staff or representatives who assist users.</li>
            <li>Attempting to bypass any security features protecting the Services.</li>
            <li>Copying or modifying the Service’s software.</li>
            <li>Decrypting, decompiling, disassembling, or reverse engineering any software associated with the Services, unless permitted by applicable law.</li>
          </ul>
        </div>
        <div class="docs__block">
          <h6>Modifications and Interruptions</h6>
          <p>We reserve the right to modify, update, or remove content from the Services at any time and for any reason at our sole discretion, without prior notice. We are not obligated to update any information on the Services and shall not be liable to you or any third party for changes, price modifications, suspensions, or termination.</p>
          <p>We cannot guarantee continuous availability of the Services. Technical issues, maintenance, or other circumstances may cause temporary unavailability, delays, or errors. We reserve the right to suspend, update, revise, or discontinue the Services at any time without notice. You acknowledge that we are not liable for any loss, damage, or inconvenience resulting from such interruptions. Nothing in these Terms requires us to maintain or provide updates, fixes, or releases for the Services.</p>
        </div>
        <div class="docs__block">
          <h6>Contact</h6>
          <p>For complaints regarding the Site or to obtain more information about its usage, please contact us at: <a href="mailto:info@alcorinnovativeltd.com">info@alcorinnovativeltd.com</a>.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.docs {
  padding-block: 200px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px
  }

  &__title {
    color: #2F327D;
    font-size: 50px;
    font-weight: 900;
    line-height: 180%;
    letter-spacing: 1px;
  }

  &__block {
    display: flex;
    flex-direction: column;
    gap: 20px;

    & ul {
      padding-left: 30px;
    }

    & h6 {
      color: #F48C06;
      font-size: 30px;
      font-weight: 900;
      line-height: 180%;
      letter-spacing: 0.6px;
    }

    & p, li {
      color: #000;
      font-size: 18px;
      font-weight: 400;
      line-height: 180%;
      letter-spacing: 0.36px;
    }
  }
}

@media (max-width: 850px) {
  .docs {
    &__title {
      font-size: 36px;
    }

    &__block {
      & h6 {
        font-size: 24px;
      }

      & p, li {
        font-size: 14px;
      }
    }
  }
}
</style>